<template>
  <div class="app-page">
    <Header ref="header" helpURL="studio/">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template #page-slot>
        <button id="header-go-to-projects-btn" class="button link-button" @click="router.push({ path: '/projects' });">Go to Projects</button>
      </template>
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <div class="dash-container">
          <OrganizationUsageSummary />
          <NewsList />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Header from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import NewsList from '@/components/News/NewsList.vue';
import OrganizationUsageSummary from '@/components/UserProfileComponent/OrganizationSettings/OrganizationUsageSummary.vue';
import { useRouter } from 'vue-router';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

const projectList = computed(() => store.state.projects.projectList);

if (!projectList.value || projectList.value.length === 0) {
  const dataConnect = new DatastoreConnect();
  dataConnect.getProjectList()
    .then((resp) => {
      if (resp.error) {
        throw resp.error;
      }

      if (resp.result.length > 0) {
        store.commit('projects/setProjectList', resp.result);
        if (!store.state.projects.currentProject) {
          store.commit('projects/setCurrentProject', resp.result[0]);
        }
      }
      return [];
    })
    .catch((error) => {
      console.error(error);
    });
}

</script>

<style lang="scss" scoped>

.main-display-area {
  overflow-y: auto;
}

.dash-container {
  display: flex;
  flex-direction: row;
  gap: 32px;
  padding: 32px;
}

@media (max-width: $breakpoint-lg) {
  .dash-container {
    flex-direction: column;
  }
}

.link-button {
  background: var(--color-primary-400);
  width: 220px;
  border-radius: 6px;
  border:var(--color-primary-200) solid 1px;
}

.link-button:hover {
  background:  var(--color-primary-300);
}

</style>
